module.exports = __webpack_public_path__ + "img/client19.837a8480.svg";